module.exports = __webpack_public_path__ + "static/img/standard.d6045892.png";